/**
 * localStorage Polyfill Setup
 * 
 * This file MUST be imported/required before ANY other code.
 * It sets up a localStorage stub to prevent Node.js webstorage errors.
 * 
 * This is a side-effect only module - it modifies the global window object.
 */

// Immediately execute to set up polyfill before any imports
(function setupLocalStoragePolyfill() {
  'use strict';
  
  // Only run in Node.js environments
  if (typeof process === 'undefined' || !process.versions || !process.versions.node) {
    return; // Browser environment - use real localStorage
  }
  
  // Only proceed if window exists (webpack/html-webpack-plugin environment)
  if (typeof window === 'undefined') {
    return; // No window - nothing to polyfill
  }
  
  // Create localStorage stub
  const stub = {
    _data: {},
    getItem: function(key) { return this._data[String(key)] || null; },
    setItem: function(key, value) { this._data[String(key)] = String(value); },
    removeItem: function(key) { delete this._data[String(key)]; },
    clear: function() { this._data = {}; },
    get length() { return Object.keys(this._data).length; },
    key: function(index) {
      const keys = Object.keys(this._data);
      return (index >= 0 && index < keys.length) ? keys[index] : null;
    }
  };
  
  // Try to install the polyfill
  try {
    // Check if property exists without accessing it
    if ('localStorage' in window) {
      // Property exists - try to override with getter
      try {
        Object.defineProperty(window, 'localStorage', {
          get: function() { return stub; },
          set: function() {},
          configurable: false,
          enumerable: true
        });
      } catch (e) {
        // Can't override - property is not configurable
        // This means Node.js webstorage might already be initialized
        // Our code will handle this with safe wrappers
      }
    } else {
      // Property doesn't exist - create it
      Object.defineProperty(window, 'localStorage', {
        value: stub,
        writable: false,
        configurable: false,
        enumerable: true
      });
    }
  } catch (e) {
    // If defineProperty fails, try direct assignment
    try {
      window.localStorage = stub;
    } catch (e2) {
      // Can't set it - code will use safe wrappers
    }
  }
})();

// Export nothing - pure side effect
export {};

